import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { AppStorage } from '../../../../Core/Service/storage-service';
import AppContext from '../../../../App/AppContext';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';
import {
    deleteImageByID,
    getChecksAddTabByID,
    getChecksEditByID,
    getImageByID,
    getTitleData,
    getTyreCheckData,
    getVehicleById,
    postChecksData,
    PostImage
} from '../../../../Core/Service/vehicleTabChecks';

export const InspectionCheCkContaxt = createContext();

export const InspectionCheckProvider = (props) => {
    console.log(props, 'props');

    const {
        displayName,
        showToast,

        portalSettings
    } = useContext(AppContext);

    const [btnLoader, setBtnLoader] = useState(false);
    const [imgLoader, setImgLoader] = useState(false);
    const localFileInputRef = useRef(null);
    const apiFileInputRef = useRef(null);

    const [state, setState] = useState({
        checksList: [],
        buttonList: [],
        passVal: false,
        imageUpload: [],
        date: moment().format('YYYY-MM-DD'),
        inspectionSheetAxlesVM: [
            { axleNumber: 1 },
            { axleNumber: 2 },
            { axleNumber: 3 },
            { axleNumber: 4 }
        ],
        VehicleDailyCheckResultsVM: [],
        vehicleInspectionID: props.data.vehicleInspectionID || null,
        vehicleInspectionScheduleID: props.sheduleID,
        vehicleDailyCheckCheckerName: displayName,
        vehicleInspectionStatusID: null,
        vehicleInspectionDateInspected: moment().format('YYYY-MM-DD'),
        vehicleInspectionResult: null,
        vehicleInspectionSignedOffComment: null,
        vehicleInspectionSignedOffName: null,
        vehicleInspectionSignedOffSignature: null,
        vehicleInspectionSignedOffDate: null,
        vehicleInspectionSignedOffIPAddress: null,
        loader: true,
        signAvailable: AppStorage.getSignature() === 'absent' ? false : true,
        windowWidth: window.innerWidth,
        axleErrors: {},
        showTost: false,
        showConfirmMessage: false,
        vehicleNoOfAxles: null,
        selectedRowInspectionID: null,
        openDefectInspection: false,
        isDisabled: false,
        inspectionSheetBrakeLiningsVM: [],
        vehicleInspectionInspectorSignature: null,
        vehicleInspectionMileagePhoto: '',
        vehicleInspectionBrakeTestPhoto: '',
        showSubmit: false,
        listOptionsVM: "",
        isSignOff: false,
        isCustomerSignOff: false,
    });
    const history = useHistory();
    let checkhaveAccess = true;

    const [flags, setFlags] = useState({});
    const [widths] = useWindowSize();
    const [isModal, setIsModal] = useState({ actionTaken: false, selectedCheck: null, showConfirm: false });
    // const { showToastSuccess, showToastError } = useToast();

    const actionTakenHandle = (check) => {
        setIsModal((st) => ({
            ...st,
            actionTaken: true,
            selectedCheck: check
        }));
    };

    const closeActionTakenhandle = (res) => {
        setIsModal((st) => ({
            ...st,
            actionTaken: false,
            selectedCheck: null,
            showConfirm: false
        }));
        if (res && props.data?.vehicleInspectionID) {
            pullEditInpectionChecks();
        }
    };

    const handleInpectionRow = (id, name) => {
        setState((st) => ({ ...st, selectedRowInspectionID: id, openDefectInspection: true, inspectionName: name }));
    };

    const closeInspection = () => {
        setState((st) => ({ ...st, selectedRowInspectionID: null, openDefectInspection: false, inspectionName: '' }));
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        if (name === 'vehicleInspectionBrakeTestTypeID') {
            setState((state) => ({ ...state, [name]: +value }));
        } else {
            setState((state) => ({ ...state, [name]: value }));
        }
    };

    // useEffect(() => {
    //     async function FetchData() {
    //         try {
    //             if (props.sheduleVechicleID) {
    //                 let vehicleInformation = await getTitleData(props.sheduleVechicleID);

    //                 if (vehicleInformation.success) {
    //                     setState((st) => ({
    //                         ...st,
    //                         vehicleInfo: vehicleInformation.data.details[0]?.vehicleDescription,
    //                         vehicleNextCalibrationDate: vehicleInformation.data.details[0]?.vehicleNextCalibrationDate,
    //                         vehicleNextTachoCalibrationDate: vehicleInformation.data.details[0]?.vehicleNextTachoCalibrationDate,
    //                         vehicleNextLolerTestDate: vehicleInformation.data.details[0]?.vehicleNextLolerTestDate,
    //                         vehicleNoOfAxles: vehicleInformation?.data?.details[0]?.vehicleNoOfAxles,
    //                         customerCompanyName: vehicleInformation?.data?.details[0]?.customerCompanyName
    //                     }));
    //                 }
    //                 let res2 = await getVehicleById(props.sheduleVechicleID);
    //                 if (res2.success) {
    //                     const data = res2.data;
    //                     setState((st) => ({
    //                         ...st,
    //                         regNumber: data.vehicleRegNumber,
    //                         modelID: data.vehicleModel,
    //                         makeID: data.vehicleMake
    //                     }));
    //                 }

    //                 // pullInpectionChecks();
    //             }
    //         } catch (error) {
    //             console.error(error);
    //         }
    //     }

    //     return FetchData();
    // }, [props.sheduleVechicleID, props.displayCheck, props.scheduleEventID, props.sheduleID]);

    //Add Inspection
    let pullInpectionChecks = async () => {
        let res = await getChecksAddTabByID(props.data.vehicleInspectionHeaderRecordID);
        let InspectionQue = res?.data?.inspectionSheetSectionsVM || [];

        if (res.success) {
            let tempArray = [];
            InspectionQue?.map((q) => {
                q.inspectionSheetChecksVM?.map((r) => {
                    r.inspectionSheetCheckResultCheckID = r.inspectionSheetCheckID;
                    r.inspectionSheetCheckResultOptionCode = null;
                    r.inspectionSheetCheckResultNotes = null;
                    r.inspectionSheetCheckResultIMReference = null;
                    r.inspectionSheetCheckResultDefectID = null;
                    tempArray.push(r);
                });
            });

            let inspectionSheetBrakeLiningsVM = res?.data?.inspectionSheetBrakeLiningsVM;

            let flagData = res?.data?.inspectionSheetTypesVM ? res?.data?.inspectionSheetTypesVM[0] : {};

            setFlags((prevFlag) => ({
                ...prevFlag,
                displayBrakePerformance: flagData.displayBrakePerformance,
                displayBrakeTest: flagData.displayBrakeTest,
                displayMileage: flagData.displayMileage,
                displayRoadTest: flagData.displayRoadTest,
                displayTyres: flagData.displayTyres,
                endEventLabel: flagData.endEventLabel,
                startEventLabel: flagData.startEventLabel,
                displayStartEvent: flagData.displayStartEvent,
                displayCustomerDeclaration: flagData.displayCustomerDeclaration,
                scheduleEventName: flagData.scheduleEventName,
                scheduleEventIs2ndSignOffRequired: flagData.scheduleEventIs2ndSignOffRequired
            }));

            setState((st) => ({
                ...st,
                checksList: res?.data?.inspectionSheetSectionsVM || [],
                buttonList: res.data?.inspectionSheetCheckOptionsVM || [],
                VehicleDailyCheckResultsVM: tempArray || [],
                loader: false,
                inspectionSheetBrakeLiningsVM: inspectionSheetBrakeLiningsVM || [],
                inspectionSheetAxlesVM:
                    st.inspectionSheetAxlesVM && st.inspectionSheetAxlesVM.length > 0
                        ? st.inspectionSheetAxlesVM
                        : [
                              { axleNumber: 1 },
                              { axleNumber: 2 },
                              { axleNumber: 3 },
                              { axleNumber: 4 }
                          ]
            }));
        }
    };

    //Edit Inspection
    let pullEditInpectionChecks = async () => {
        let isSignOff = false;
        let isCustomerSignOff = false;
        if (props.data.vehicleInspectionID) {
            let res = await getChecksEditByID(props.data.vehicleInspectionID);

            let TempData = [...res.data.vehicleDailyChecksResult];

            let checksList = TempData.map((m, i) => {
                let checksObject;
                if (TempData.length > 0) {
                    checksObject = TempData.filter((p) => {
                        if (m.inspectionSheetSectionDescription === p.inspectionSheetSectionDescription) {
                            if (p.defectStatusID === 3) {
                                isCustomerSignOff = true;
                            } else if (p.defectStatusID === 1) {
                                isSignOff = true;
                            }
                            return m;
                        }
                    });
                }
                checksObject.name = m.inspectionSheetSectionDescription;
                return checksObject;
            });


            if (res.success) {
                res.data.vehicleDailyChecks.map((item) => {
                    if (item.vehicleInspectionSignedOffSignature) {
                        setState((st) => ({
                            ...st,
                            showbtn: false
                        }));
                    }
                    setState((st) => ({
                        ...st,
                        vehicleID: item.vehicleID,
                        vehicleRegNumber: item.vehicleRegNumber,
                        date: moment(item.vehicleInspectionDateInspected).format('YYYY-MM-DD'),
                        makeID: item.vehicleMake,
                        modelID: item.vehicleModel,
                        imgtechniciansign: item.vehicleInspectionInspectorSignature,
                        techniciansign: item.vehicleInspectionInspectorSignature,
                        vehicleInspectionInspectorSignature: item.vehicleInspectionInspectorSignature,
                        vehicleInspectionScheduleID: item.vehicleInspectionScheduleID,
                        vehicleInspectionStatusID: item.vehicleInspectionStatusID,
                        isRetrunedToEnginner: item.vehicleInspectionStatusID === 3,
                        vehicleInspectionDateInspected: moment(item.vehicleInspectionDateInspected).format('YYYY-MM-DD hh:mm'),
                        vehicleInspectionResult: item.vehicleInspectionResult,
                        vehicleDailyCheckMileage: item.vehicleInspectionMileage,
                        vehicleInspectionSlippageReasonID: item.vehicleInspectionSlippageReasonID,
                        vehicleDailyCheckCheckerName: item.vehicleInspectionInspectorName || displayName,
                        vehicleInspectionInspectionComment: item.vehicleInspectionInspectionComment,
                        vehicleInspectionSignedOffName: item.vehicleInspectionSignedOffName,
                        vehicleInspectionSignedOffSignature: item.vehicleInspectionSignedOffSignature,
                        signOffsignature: item.vehicleInspectionSignedOffSignature,
                        hideSignOff: item.vehicleInspectionSignedOffSignature,
                        vehicleInspectionSignedOffDate: item.vehicleInspectionSignedOffDate,
                        vehicleInspectionSignedOffIPAddress: item.vehicleInspectionSignedOffIPAddress,
                        vehicleInspectionID: item.vehicleInspectionID,
                        vehicleInspectionSignedOffComment: item.vehicleInspectionSignedOffComment,

                        vehicleInspectionBrakeTestTypeID: item.vehicleInspectionBrakeTestTypeID, // 2,
                        vehicleInspectionBrakeTestNumber: item.vehicleInspectionBrakeTestNumber, // "12345",
                        vehicleInspectionRoadCondition: item.vehicleInspectionRoadCondition, // "Test Road Conditions",
                        vehicleInspectionServiceBrakePerformance: item.vehicleInspectionServiceBrakePerformance, // 71,
                        vehicleInspectionSecondaryBrakePerformance: item.vehicleInspectionSecondaryBrakePerformance, // 72,
                        vehicleInspectionParkingBrakePerformance: item.vehicleInspectionParkingBrakePerformance, // 73,
                        vehicleInspectionBrakeTestPhoto: item.vehicleInspectionBrakeTestPhoto,
                        vehicleInspectionMileagePhoto: item.vehicleInspectionMileagePhoto || item.VehicleInspectionMileagePhoto || '',
                        isDisabled: Boolean(item.vehicleInspectionInspectorSignature)
                    }));
                });

                let TempData = [...res.data.vehicleDailyChecksResult];
                let flagData = res.data.inspectionSheetTypesVM[0];

                let tempArray = res.data.vehicleDailyChecksResult?.map((q) => ({
                    ...q,
                    inspectionSheetCheckResultCheckID: q.inspectionSheetCheckID,
                    inspectionSheetCheckResultOptionCode: q.inspectionSheetCheckResultOptionCode || null,
                    inspectionSheetCheckResultNotes: q.inspectionSheetCheckResultNotes || null,
                    inspectionSheetCheckResultIMReference: q.inspectionSheetCheckResultIMReference || null,
                    inspectionSheetCheckResultDefectID: q.inspectionSheetCheckResultDefectID || null
                }));

                let inspectionSheetBrakeLiningsVM = res?.data?.inspectionSheetBrakeLiningsVM;

                const axles = [1, 2, 3, 4].map((num) => res?.data?.tyreAxles.find((x) => x.axleNumber === num) || { axleNumber: num });

                setFlags((prevFlag) => ({
                    ...prevFlag,
                    displayBrakePerformance: flagData?.displayBrakePerformance,
                    displayBrakeTest: flagData?.displayBrakeTest,
                    displayMileage: flagData?.displayMileage,
                    displayRoadTest: flagData?.displayRoadTest,
                    displayTyres: flagData?.displayTyres,
                    endEventLabel: flagData?.endEventLabel,
                    startEventLabel: flagData?.startEventLabel,
                    displayStartEvent: flagData?.displayStartEvent,
                    displayCustomerDeclaration: flagData?.displayCustomerDeclaration,
                    scheduleEventName: flagData?.scheduleEventName,
                    scheduleEventIs2ndSignOffRequired:
                        flagData?.scheduleEventIs2ndSignOffRequired ??
                        flagData?.is2ndSignOffRequired ??
                        res?.data?.scheduleEventIs2ndSignOffRequired ??
                        false,
                    fileCount: flagData.fileCount
                }));
                setState((st) => ({
                    ...st,
                    inspectionSheetAxlesVM: axles,
                    loader: false,
                    buttonList: res.data?.vehicleDailyCheckOptions,
                    VehicleDailyCheckResultsVM: tempArray,
                    inspectionSheetBrakeLiningsVM: inspectionSheetBrakeLiningsVM || [],
                    listOptionsVM: res.data.listOptionsVM,
                    scheduleEventID: flagData.scheduleEventID,
                    isSignOff: isSignOff,
                    isCustomerSignOff: isCustomerSignOff,

                }));
            }
        }
    };

    useEffect(() => {
        if (props.data.vehicleInspectionID) {
            pullEditInpectionChecks();
        } else {
            pullInpectionChecks();
        }
    }, [props.data.vehicleInspectionID]);

    useEffect(() => {
        if (props.data.vehicleInspectionID) {
            if (state.VehicleDailyCheckResultsVM.length > 0) {
                let checksList = state.VehicleDailyCheckResultsVM.map((m, i) => {
                    return {
                        inspectionSheetSectionID: m.inspectionSheetSectionID || m.inspectionSheetCheckSectionID || i,
                        inspectionSheetSectionDescription: m.inspectionSheetSectionDescription,
                        inspectionSheetSectionSeprator: m.inspectionSheetSectionSeprator,
                        inspectionSheetChecksVM: state.VehicleDailyCheckResultsVM.filter(
                            (p) => m.inspectionSheetSectionDescription === p.inspectionSheetSectionDescription && (p.inspectionSheetCheckDescription || p.inspectionSheetCheckID)
                        ).map((list) => ({
                            ...list,
                            inspectionSheetCheckCanHideDefectDescription: list.inspectionSheetCheckCanHideDefectDescription,
                            inspectionSheetCheckCanHidePhotoUpload: list.inspectionSheetCheckCanHidePhotoUpload,
                            inspectionSheetCheckDescription: list.inspectionSheetCheckDescription,
                            inspectionSheetCheckFreeTextField: list.inspectionSheetCheckFreeTextField,
                            inspectionSheetCheckID: list.inspectionSheetCheckID,
                            inspectionSheetCheckResultOptionCode: list.inspectionSheetCheckResultOptionCode || '',
                            previousNotes: '',
                            previousResultCode: '',
                            previousVehicleInspectionID: 0,
                            startFreeText: list.startFreeText,
                            startInspectionSheetCheckResultID: list.startInspectionSheetCheckResultID,
                            startNotes: list.startNotes,
                            startPhotosUploaded: list.startPhotosUploaded,
                            startResultCode: list.startResultCode,
                            startVehicleInspectionID: list.startVehicleInspectionID,
                            inspectionSheetCheckResultNotes: list.inspectionSheetCheckResultNotes
                        }))
                    };
                });

                let vehicleChecksList = Object.values(
                    checksList.reduce((acc, cur) => Object.assign(acc, { [cur.inspectionSheetSectionDescription]: cur }), {})
                );
                setState((st) => ({ ...st, checksList: vehicleChecksList }));
            }
        }
    }, [state.VehicleDailyCheckResultsVM, props.data.vehicleInspectionID]);

    let getPreviousTyreData = async () => {
        let res = await getTyreCheckData(props.sheduleVechicleID);
        if (res.success) {
            if (res.data.previousAxle.length > 0) {
                setState((st) => ({ ...st, inspectionSheetAxlesVM: [...res.data.previousAxle] }));
                showToast('Data Added Successfully');
            } else {
                showToast('No Record Found');
            }
        } else {
            showToast(res.data.message);
        }
    };

    //Signature

    const signCanvas = useRef({});

    const clear = () => {
        if (state.imgtechniciansign) {
            setState((st) => ({
                ...st,
                imgtechniciansign: false,
                techniciansign: null
            }));
        } else {
            setState((st) => ({ ...st, techniciansign: null }));
            signCanvas.current.clear();
        }
    };

    const GetTechnicianSign = () => {
        setState((st) => {
            const nst = {
                ...st,
                techniciansign: signCanvas.current.toDataURL()
            };
            return nst;
        });
    };

    const useDefaultSig = () => {
        setState((st) => ({ ...st, imgtechniciansign: true, techniciansign: AppStorage.getSignature() }));
    };

    console.log(state.techniciansign, 'techniciansign');

    useEffect(() => {
        const handleResize = () => {
            if (
                signCanvas.current &&
                typeof signCanvas.current.fromDataURL === 'function' &&
                state.techniciansign &&
                !state.imgtechniciansign // only restore if not using default
            ) {
                signCanvas.current.fromDataURL(state.techniciansign);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [state.techniciansign, state.imgtechniciansign]);

    //Handle Inspections

    const changeState = useCallback(
        (buttonVal, checkId) => {
            // console.log(buttonVal, checkId);
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === checkId);
            if (objIndex > -1) {
                changedArray[objIndex].inspectionSheetCheckResultOptionCode = buttonVal;
                setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray }));
            }
        },
        [state.VehicleDailyCheckResultsVM]
    );

    const changeNotesState = useCallback(
        (id, des) => (e) => {
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === id);
            changedArray[objIndex].inspectionSheetCheckResultNotes = e.target.value;
            setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray }));
        },
        [state.VehicleDailyCheckResultsVM]
    );
    const changeResutNotesState = useCallback(
        (id, des) => (e) => {
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === id);
            changedArray[objIndex].inspectionSheetCheckResultEnteredText = e.target.value;
            setState((st) => ({ ...st, VehicleDailyCheckResultsVM: changedArray }));
        },
        [state.VehicleDailyCheckResultsVM]
    );

    const changeAllChildChecks = (buttonId, condition, groupLabel) => () => {
        const grp = state.checksList.find((l) => l.inspectionSheetSectionDescription === groupLabel);
        if (grp.state === true) {
            grp.state = false;
        } else {
            grp.state = condition;
        }
        if (grp) {
            const sheetsCheckIds = grp.inspectionSheetChecksVM.map((p) => p.inspectionSheetCheckID);
            setState((st) => {
                const newSt = { ...st };
                sheetsCheckIds.forEach((id) => {
                    const sheetsCheck = newSt.VehicleDailyCheckResultsVM.find((c) => c.inspectionSheetCheckID === id);
                    if (sheetsCheck) {
                        sheetsCheck.inspectionSheetCheckResultOptionCode = grp.state ? buttonId : null;
                        newSt[id] = grp.state ? buttonId : null;
                    }
                });
                return { ...newSt, VehicleDailyCheckResultsVM: [...newSt.VehicleDailyCheckResultsVM] };
            });
        }
    };

    //Handle Inspection tyress --> Copy Data

    const handleInspection = () => {
        setState((st) => {
            const currentAxles = [...(st.inspectionSheetAxlesVM || [])];
            const axle1 = currentAxles.find((a) => Number(a.axleNumber) === 1) || {};
            const depth = axle1.osTreadDepth !== undefined && axle1.osTreadDepth !== null ? axle1.osTreadDepth : null;
            const pressure = axle1.osTyrePressure !== undefined && axle1.osTyrePressure !== null ? axle1.osTyrePressure : null;
            const breaks = axle1.osBrakeLineRemaining !== undefined && axle1.osBrakeLineRemaining !== null ? axle1.osBrakeLineRemaining : null;

            const updatedAxles = [1, 2, 3, 4].map((num) => {
                const existing = currentAxles.find((a) => Number(a.axleNumber) === num) || { axleNumber: num };
                if (num === 1) {
                    return {
                        ...existing,
                        axleNumber: 1,
                        nsTreadDepth: existing.nsTreadDepth ?? depth,
                        osTreadDepth: existing.osTreadDepth ?? depth,
                        nsTyrePressure: existing.nsTyrePressure ?? pressure,
                        osTyrePressure: existing.osTyrePressure ?? pressure,
                        nsBrakeLineRemaining: existing.nsBrakeLineRemaining ?? breaks,
                        osBrakeLineRemaining: existing.osBrakeLineRemaining ?? breaks
                    };
                }
                return {
                    ...existing,
                    axleNumber: num,
                    osTreadDepth: depth ?? existing.osTreadDepth,
                    nsTreadDepth: depth ?? existing.nsTreadDepth,
                    osFrontTreadDepth: depth ?? existing.osFrontTreadDepth,
                    nsFrontTreadDepth: depth ?? existing.nsFrontTreadDepth,
                    osTyrePressure: pressure ?? existing.osTyrePressure,
                    nsTyrePressure: pressure ?? existing.nsTyrePressure,
                    osFrontTyrePressure: pressure ?? existing.osFrontTyrePressure,
                    nsFrontTyrePressure: pressure ?? existing.nsFrontTyrePressure,
                    osBrakeLineRemaining: breaks ?? existing.osBrakeLineRemaining,
                    nsBrakeLineRemaining: breaks ?? existing.nsBrakeLineRemaining
                };
            });

            return {
                ...st,
                inspectionSheetAxlesVM: updatedAxles
            };
        });
    };

    const handleInputs = (axelNo) => (e) => {
        let showError = {};
        const { name, value } = e.target;
        let showTost = false;
        setState((st) => {
            const currentAxles = [...(st.inspectionSheetAxlesVM || [])];
            const axIndex = currentAxles.findIndex((a) => Number(a.axleNumber) === Number(axelNo));
            if (axIndex !== -1) {
                currentAxles[axIndex] = { ...currentAxles[axIndex], [name]: value };
            } else {
                currentAxles.push({ axleNumber: Number(axelNo), [name]: value });
            }

            switch (name) {
                case 'osTreadDepth':
                case 'nsTreadDepth':
                case 'osFrontTreadDepth':
                case 'nsFrontTreadDepth':
                    showError.message = (value > 0 && value > 20) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 20 and greater than 0` : null;
                    showTost = Boolean(showError.message);
                    break;
                case 'osTyrePressure':
                case 'nsTyrePressure':
                case 'osFrontTyrePressure':
                case 'nsFrontTyrePressure':
                    showError.message = (value > 0 && value > 130) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 130 and greater than 0` : null;
                    showTost = Boolean(showError.message);
                    break;
                case 'nsBrakeLineRemaining':
                case 'osBrakeLineRemaining':
                    showError.message = (value > 0 && value > 100) || value < 0 ? `Axle ${axelNo} ${name}  must be Smaller than 100 and greater than 0` : null;
                    showTost = Boolean(showError.message);
                    break;

                default:
                    showError.message = null;
                    showTost = false;
                    break;
            }

            const errorKey = Number(axelNo) === 1 ? 'axelone' : Number(axelNo) === 2 ? 'axeltwo' : Number(axelNo) === 3 ? 'axelthree' : 'axelfour';
            const updatedErrors = { ...(st.errors || {}) };
            delete updatedErrors[errorKey];

            return {
                ...st,
                inspectionSheetAxlesVM: currentAxles,
                axleErrors: showError,
                showTost: showTost,
                errors: updatedErrors
            };
        });
    };

    //Submit Data...........

    const validations = () => {
        let formIsValid = true;
        let errors = {};
        let errorMessage = '';

        const checkIsLegalReqFields = state.VehicleDailyCheckResultsVM.filter(
            (x) =>
                x.inspectionSheetCheckLegalRequirement === true &&
                x.inspectionSheetCheckFieldTypeID === "CO" &&
                !x.inspectionSheetCheckResultOptionCode
        );

        const checkIsLegalReqText = state.VehicleDailyCheckResultsVM.filter(
            (x) =>
                x.inspectionSheetCheckLegalRequirement === true &&
                x.inspectionSheetCheckFieldTypeID !== "CO" &&
                !x.inspectionSheetCheckResultEnteredText
        );
        let checkIsPhotoMandatory = state.VehicleDailyCheckResultsVM.filter((x) => {
            const isListFailed =
                x.inspectionSheetCheckFieldTypeID === 'LT' &&
                state.listOptionsVM?.some(
                    (k) =>
                        k.inspectionSheetListId === x.inspectionSheetCheckListTypeID &&
                        k.name === x.inspectionSheetCheckResultEnteredText &&
                        (k.setFailed === true || String(k.setFailed).toLowerCase() === 'true')
                );
            const isPhotoMandatoryOnFail =
                x.inspectionSheetCheckPhotoMandatoryOnfail === true ||
                String(x.inspectionSheetCheckPhotoMandatoryOnfail).toLowerCase() === 'true';

            const isPhotoMandatory =
                x.inspectionSheetCheckPhotoMandatory === true ||
                String(x.inspectionSheetCheckPhotoMandatory).toLowerCase() === 'true' ||
                ((x.inspectionSheetCheckResultOptionCode === 'D' || isListFailed) && isPhotoMandatoryOnFail);

            return isPhotoMandatory &&
                !(x.photosUploaded > 0 || x.startPhotosUploaded > 0 || x.basicCount > 0);
        });

        let checksNotes = state.VehicleDailyCheckResultsVM.filter((x) => {
            return x.inspectionSheetCheckResultOptionCode === 'D' && (x.inspectionSheetCheckResultNotes == null || x.inspectionSheetCheckResultNotes === '');
        });
        const requiredAxleFields = [
            'osTreadDepth',
            'nsTreadDepth',
            'osBrakeLineRemaining',
            'nsBrakeLineRemaining',
            'osTyrePressure',
            'nsTyrePressure'
        ];

        const isAxleValid = (axleNum) => {
            const ax = (state.inspectionSheetAxlesVM || []).find((a) => Number(a.axleNumber) === Number(axleNum));
            if (!ax) return false;
            return requiredAxleFields.every((key) => {
                const val = ax[key];
                return val !== undefined && val !== null && String(val).trim() !== '';
            });
        };

        const isAxel1Valid = isAxleValid(1);
        const isAxel2Valid = isAxleValid(2);
        const isAxel3Valid = isAxleValid(3);
        const isAxel4Valid = isAxleValid(4);

        if (flags.displayMileage) {
            if (!state.vehicleDailyCheckMileage) {
                errors.vehicleDailyCheckMileage = `Odometer Reading is required`;
                errorMessage = errorMessage.concat(errors.vehicleDailyCheckMileage) + '\n';
                formIsValid = false;
            }
            if (!state.vehicleInspectionMileagePhoto) {
                errors.vehicleInspectionMileagePhoto = `Odometer photo is required`;
                errorMessage = errorMessage.concat(errors.vehicleInspectionMileagePhoto) + '\n';
                formIsValid = false;
            }
        }

        // if (checksOption.length > 0) {
        //     errors.message = 'This field is required';
        //     formIsValid = false;
        // }
        if (flags.displayTyres) {
            const noOfAxles = Number(state.vehicleNoOfAxles);
            if (noOfAxles) {
                if (noOfAxles >= 1 && !isAxel1Valid) {
                    errors.axelone = 'Axel 1 fields are required';
                    errorMessage = errorMessage.concat(errors.axelone) + '\n';
                    formIsValid = false;
                }
                if (noOfAxles >= 2 && !isAxel2Valid) {
                    errors.axeltwo = 'Axel 2 fields are required';
                    errorMessage = errorMessage.concat(errors.axeltwo) + '\n';
                    formIsValid = false;
                }
                if (noOfAxles >= 3 && !isAxel3Valid) {
                    errors.axelthree = 'Axel 3 fields are required';
                    errorMessage = errorMessage.concat(errors.axelthree) + '\n';
                    formIsValid = false;
                }
                if (noOfAxles >= 4 && !isAxel4Valid) {
                    errors.axelfour = 'Axel 4 fields are required';
                    errorMessage = errorMessage.concat(errors.axelfour) + '\n';
                    formIsValid = false;
                }
            } else {
                if (!isAxel1Valid) {
                    errors.axelone = 'Axel 1 fields are required';
                    errorMessage = errorMessage.concat(errors.axelone) + '\n';
                    formIsValid = false;
                }

                if (!isAxel2Valid) {
                    errors.axeltwo = 'Axel 2 fields are required';
                    errorMessage = errorMessage.concat(errors.axeltwo) + '\n';
                    formIsValid = false;
                }
            }
        }

        if (checksNotes.length > 0) {
            errors.note = 'Note is required';
            let notesError = checksNotes.map((x) => `Defect Note of (${x.inspectionSheetCheckDescription}) is required`).join('\n');

            errorMessage = errorMessage.concat(notesError) + '\n';
            formIsValid = false;
        }

        if (!state.techniciansign) {
            errors.techniciansign = 'Signature is required';
            errorMessage = errorMessage.concat(errors.techniciansign) + '\n';
            formIsValid = false;
        }

        if (checkIsLegalReqFields.length > 0) {
            let legalReqNames = checkIsLegalReqFields.map((x) => `- ${x.inspectionSheetCheckDescription}`).join('\n');
            errors.legalReq = `Please complete the following mandatory legal requirement checks:\n${legalReqNames}`;
            errorMessage = errorMessage.concat(errors.legalReq) + '\n';
            formIsValid = false;
        }
        if (checkIsLegalReqText.length > 0) {
            let legalReqTextNames = checkIsLegalReqText.map((x) => `- ${x.inspectionSheetCheckDescription}`).join('\n');
            errors.legalReqText = `Please fill result for the following mandatory legal requirement checks:\n${legalReqTextNames}`;
            errorMessage = errorMessage.concat(errors.legalReqText) + '\n';
            formIsValid = false;
        }
        if (checkIsPhotoMandatory.length > 0) {
            let photoReqNames = checkIsPhotoMandatory.map((x) => `- ${x.inspectionSheetCheckDescription}`).join('\n');
            errors.photoReq = `Please upload a photo for the following mandatory photo checks:\n${photoReqNames}`;
            errorMessage = errorMessage.concat(errors.photoReq) + '\n';
            formIsValid = false;
        }
        // if (!state.vehicleInspectionInspectionComment) {
        //     errors.vehicleInspectionInspectionComment = 'Vehicle checker Comment is required';
        //     formIsValid = false;
        // }
        setState((st) => ({
            ...st,
            errors: errors
        }));
        // return true;
        if (errorMessage) {
            alert(errorMessage);
        }
        return formIsValid;
    };

    const handleConfirmPopup = () => {
        if (validations()) {
            setBtnLoader(true);
            setState((st) => ({
                ...st,
                showConfirmMessage: !st.showConfirmMessage
            }));
            setBtnLoader(false);
        }
    };

    const submitData = async (status) => {
        if (status === 6 && !state.vehicleInspectionSignedOffSignature) {
            setState((st) => ({
                ...st,
                errors: {
                    ...st?.errors,
                    vehicleInspectionSignedOffSignature: 'Signature is required'
                }
            }));
            return;
        }

        let resultVM = state.VehicleDailyCheckResultsVM.filter(k => k.inspectionSheetCheckResultCheckID !== null).map((e) => ({
            inspectionSheetCheckResultCheckID: e.inspectionSheetCheckResultCheckID,
            inspectionSheetCheckResultOptionCode: e.inspectionSheetCheckResultOptionCode,
            inspectionSheetCheckResultNotes: e.inspectionSheetCheckResultNotes,
            inspectionSheetCheckResultIMReference: e.inspectionSheetCheckResultIMReference,
            inspectionSheetCheckResultDefectID: e.inspectionSheetCheckResultDefectID,
            inspectionSheetCheckResultEnteredText: e.inspectionSheetCheckResultEnteredText
        }));

        const axleValueFields = [
            'osFrontTreadDepth',
            'nsFrontTreadDepth',
            'osFrontTyrePressure',
            'nsFrontTyrePressure',
            'osFrontTyreMaker',
            'nsFrontTyreMaker',
            'osTreadDepth',
            'nsTreadDepth',
            'osTyrePressure',
            'nsTyrePressure',
            'osTyreMaker',
            'nsTyreMaker',
            'osBrakeLineRemaining',
            'nsBrakeLineRemaining'
        ];

        let sanitizedAxles = (state.inspectionSheetAxlesVM || [])
            .map((ax) => {
                let cleaned = { ...ax };
                axleValueFields.forEach((field) => {
                    if (cleaned[field] === '' || cleaned[field] === undefined) {
                        cleaned[field] = null;
                    }
                });
                return cleaned;
            })
            .filter((ax) => {
                return axleValueFields.some(
                    (field) => ax[field] !== null && ax[field] !== undefined && String(ax[field]).trim() !== ''
                );
            });

        let DataRow = {
            vehicleInspectionScheduleID: state.vehicleInspectionScheduleID,
            vehicleInspectionStatusID: status,
            vehicleInspectionDateInspected: state.date,
            vehicleInspectionResult: state.vehicleInspectionResult,
            vehicleInspectionHeaderRecordID: props.data.vehicleInspectionHeaderRecordID,
            vehicleInspectionMileage: state.vehicleDailyCheckMileage,
            vehicleInspectionInspectorName: state.vehicleDailyCheckCheckerName,
            vehicleInspectionInspectorSignature: state.techniciansign,
            vehicleInspectionInspectionComment: state.vehicleInspectionInspectionComment,
            vehicleInspectionSignedOffName: state.vehicleInspectionSignedOffName,
            vehicleInspectionSignedOffSignature: state.vehicleInspectionSignedOffSignature,
            vehicleInspectionSignedOffDate: state.vehicleInspectionSignedOffDate,
            vehicleInspectionSignedOffIPAddress: state.vehicleInspectionSignedOffIPAddress,
            vehicleInspectionBrakeTestTypeID: state.vehicleInspectionBrakeTestTypeID,
            vehicleInspectionBrakeTestNumber: state.vehicleInspectionBrakeTestNumber,
            vehicleInspectionRoadCondition: state.vehicleInspectionRoadCondition,
            vehicleInspectionServiceBrakePerformance: state.vehicleInspectionServiceBrakePerformance,
            vehicleInspectionSecondaryBrakePerformance: state.vehicleInspectionSecondaryBrakePerformance,
            vehicleInspectionParkingBrakePerformance: state.vehicleInspectionParkingBrakePerformance,
            vehicleInspectionID: state.vehicleInspectionID,
            vehicleInspectionSignedOffComment: state.vehicleInspectionSignedOffComment,
            inspectionSheetCheckResultsVM: resultVM,
            inspectionSheetAxlesVM: sanitizedAxles,
            inspectionSheetCheckPhotoVM: state.imageUpload,
            vehicleInspectionBrakeTestPhoto: state.vehicleInspectionBrakeTestPhoto || '',
            vehicleInspectionMileagePhoto: state.vehicleInspectionMileagePhoto || '',
            scheduleEventID: state.scheduleEventID
        };
        try {
            setBtnLoader(true);
            let res = await postChecksData(DataRow);
            if (res.success) {
                showToast('Vehicle Checks added successfully');
                if (checkhaveAccess?.CanViewJobs && res?.data?.jobID) {
                    history.push({
                        pathname: `/controller/jobTabScreen/${res.data?.jobID}/${props.sheduleVechicleID}`,
                        state: 'jobs',
                        search: 'tab_testing_tabs=1'
                    });
                    props.onClose(true);
                } else {
                    props.onClose(true);
                }
                setBtnLoader(false);
            } else {
                showToast(res.message);
                setBtnLoader(false);
            }
        } catch (error) {
            setBtnLoader(false);
            showToast(`An error occurred: ${error.message}`);
        }
    };

    //Image Handler
    //     if (hideImg && hideDefect) {
    //         colSpan = 3;
    //     } else if (hideDefect || hideImg) {
    //         colSpan = hideDefect ? 1 : 2;
    //     } else {
    //         colSpan = 1;
    //     }

    //     return colSpan;
    // };

    //Image Handler
    const imageHandler = async (ResultID = null, inspectioncheckID, count = 0, isDiabled = false) => {
        if (props.data?.vehicleInspectionID || count > 0) {
            try {
                let res = await getImageByID(ResultID);
                let imageList = [...(res?.data?.list || [])];
                if (res?.data?.list && res.data.list.length > 0) {
                    setState((st) => ({
                        ...st,
                        showImageModal: false,
                        showImageModalAPI: true,
                        inspectioncheckID: inspectioncheckID,
                        inspectionCheckResultID: ResultID,
                        selectedImages: imageList.map((m) => m.vehicleInspectionsPhotoObject) || [],
                        getImageList: imageList || [],
                        fromAPI: ResultID ? true : false,
                        isModalReadonly: isDiabled ? isDiabled : false
                    }));
                } else {
                    let changedArray = [...state.VehicleDailyCheckResultsVM];
                    let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === inspectioncheckID);
                    const localImages = changedArray[objIndex]?.images || [];
                    if (localImages.length > 0) {
                        setState((st) => ({
                            ...st,
                            showImageModal: true,
                            showImageModalAPI: false,
                            inspectioncheckID: inspectioncheckID,
                            selectedImages: localImages,
                            isModalReadonly: isDiabled ? isDiabled : false,
                            fromAPI: false
                        }));
                    } else {
                        setState((st) => ({
                            ...st,
                            showImageModal: false,
                            showImageModalAPI: false,
                            inspectioncheckID: inspectioncheckID,
                            selectedImages: [],
                            isModalReadonly: isDiabled ? isDiabled : false,
                            fromAPI: false
                        }));
                        setTimeout(() => {
                            if (localFileInputRef.current) {
                                localFileInputRef.current.click();
                            }
                        }, 50);
                    }
                }
            } catch (error) {
                showToast('Error fetching images');
            }
        } else {
            let changedArray = [...state.VehicleDailyCheckResultsVM];
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === inspectioncheckID);
            const localImages = changedArray[objIndex]?.images || [];
            if (localImages.length > 0) {
                setState((st) => ({
                    ...st,
                    showImageModal: true,
                    showImageModalAPI: false,
                    inspectioncheckID: inspectioncheckID,
                    selectedImages: localImages,
                    isModalReadonly: isDiabled ? isDiabled : false,
                    fromAPI: false
                }));
            } else {
                setState((st) => ({
                    ...st,
                    showImageModal: false,
                    showImageModalAPI: false,
                    inspectioncheckID: inspectioncheckID,
                    selectedImages: [],
                    isModalReadonly: isDiabled ? isDiabled : false,
                    fromAPI: false
                }));
                setTimeout(() => {
                    if (localFileInputRef.current) {
                        localFileInputRef.current.click();
                    }
                }, 50);
            }
        }
    };

    // const InHire_imageHandler = async (inspectionCheckResultID) => {
    //     let res = await getImageByID(inspectionCheckResultID);
    //     if (!res.data.list) {
    //         let changedArray = [...state.ChecksObj];
    //         let objIndex = state.ChecksObj.findIndex((x) => x.inspectionSheetCheckResultID === inspectionCheckResultID);
    //         setState((st) => ({
    //             ...st,
    //             isDisabled: true,
    //             showImageModal: true,
    //             inspectionCheckResultID: inspectionCheckResultID,
    //             selectedImages: changedArray[objIndex].images || []
    //         }));
    //     } else {
    //         setState((st) => ({
    //             ...st,
    //             isDisabled: true,
    //             showImageModal: true,
    //             inspectionCheckResultID: inspectionCheckResultID,
    //             selectedImages: res.data.list.map((m) => m.vehicleInspectionsPhotoObject) || []
    //         }));
    //     }
    // };

    const sumbitImage = () => {
        setImgLoader(true);
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === state.inspectioncheckID);
        if (objIndex > -1) {
            let imgCount = (state.selectedImages || []).length;
            changedArray[objIndex].basicCount = imgCount;
            changedArray[objIndex].photosUploaded = imgCount;
            changedArray[objIndex].images = state.selectedImages || [];
            showToast('Images saved successfully');
        }
        setState((st) => ({ ...st, showImageModal: false, showImageModalAPI: false, VehicleDailyCheckResultsVM: changedArray, showSubmit: false }));
        setImgLoader(false);
    };

    const sumbitImageApi = async () => {
        setImgLoader(true);
        try {
            let tempArray = [...(state.postImagesList || [])];
            if (tempArray.length > 0) {
                let data = {
                    vehicleInspectionsPhotoID: null,
                    vehicleInspectionsPhotoResultID: state.inspectionCheckResultID,
                    vehicleInspectionsPhotoObject: tempArray
                };
                let res = await PostImage(data);
                if (res.success) {
                    let changedArray = [...state.VehicleDailyCheckResultsVM];
                    let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckResultID === state.inspectionCheckResultID);
                    if (objIndex > -1) {
                        changedArray[objIndex].basicCount = (state.selectedImages || []).length;
                        changedArray[objIndex].photosUploaded = (state.selectedImages || []).length;
                    }
                    showToast('Images uploaded successfully');

                    setState((st) => ({
                        ...st,
                        showImageModal: false,
                        showImageModalAPI: false,
                        VehicleDailyCheckResultsVM: changedArray,
                        showSubmit: false,
                        postImagesList: []
                    }));
                }
            } else {
                let changedArray = [...state.VehicleDailyCheckResultsVM];
                let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckResultID === state.inspectionCheckResultID);
                if (objIndex > -1) {
                    changedArray[objIndex].basicCount = (state.selectedImages || []).length;
                    changedArray[objIndex].photosUploaded = (state.selectedImages || []).length;
                }
                setState((st) => ({
                    ...st,
                    showImageModal: false,
                    showImageModalAPI: false,
                    VehicleDailyCheckResultsVM: changedArray,
                    showSubmit: false,
                    postImagesList: []
                }));
            }
        } catch (error) {
            console.error('Error submitting images:', error);
            showToast('Failed to upload images');
        }
        setImgLoader(false);
    };

    const onImageChangeAPI = (imageList) => {
        setImgLoader(true);
        // console.log(imageList, 'imageList');
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let FilterimagesList;
        let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckResultID === state.inspectionCheckResultID);

        if (objIndex > -1) {
            FilterimagesList = imageList.map((m) => (m.data_url ? m.data_url : m));
            changedArray[objIndex].images = FilterimagesList;
        }
        let UploadedPhoto = imageList.filter((k) => k.data_url);
        let uniqueImages = UploadedPhoto.map((k) => k.data_url);

        setState((st) => ({
            ...st,
            VehicleDailyCheckResultsVM: changedArray,
            selectedImages: FilterimagesList,
            postImagesList: uniqueImages,
            showSubmit: true
        }));
        setImgLoader(false);
    };

    const onImageChange = (imageList) => {
        setImgLoader(true);
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let FilterimagesList;

        // Find index based on inspectionSheetCheckID
        let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === state.inspectioncheckID);
        if (objIndex !== -1) {
            FilterimagesList = imageList.map((m) => (m.data_url ? m.data_url : m));
            changedArray[objIndex].images = FilterimagesList;
            changedArray[objIndex].basicCount = FilterimagesList.length;
            changedArray[objIndex].photosUploaded = FilterimagesList.length;
        }

        let tempArray = [...state.imageUpload];
        let tempArrayObjIndex = tempArray.findIndex((x) => x.inspectionSheetCheckCheckID === state.inspectioncheckID);

        if (tempArrayObjIndex !== -1) {
            tempArray[tempArrayObjIndex].inspectionSheetCheckPhotos = [...FilterimagesList];
        } else {
            tempArray.push({ inspectionSheetCheckCheckID: state.inspectioncheckID, inspectionSheetCheckPhotos: FilterimagesList });
        }

        setState((st) => ({
            ...st,
            VehicleDailyCheckResultsVM: changedArray,
            selectedImages: FilterimagesList,
            imageUpload: tempArray,
            showSubmit: true
        }));
        setImgLoader(false);
    };

    const RemoveImage = async (val, i) => {
        setImgLoader(true);
        const tempList = [...state.getImageList];
        let changedArray = [...state.VehicleDailyCheckResultsVM];
        let FilterimagesList = [...state.selectedImages];
        let tempObj = tempList.findIndex((k) => k.vehicleInspectionsPhotoObject == val);

        if (tempObj === i) {
            let res = await deleteImageByID(tempList[i].vehicleInspectionPhotoID);
            if (res.success) {
                let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === state.inspectioncheckID);
                if (objIndex !== -1) {
                    // let index = state.selectedImages.findIndex((k) => k === val);
                    FilterimagesList.splice(i, 1);

                    changedArray[objIndex].images = FilterimagesList;
                    changedArray[objIndex].basicCount = FilterimagesList.length;
                    changedArray[objIndex].photosUploaded = FilterimagesList.length;
                }
                setState((st) => ({
                    ...st,
                    VehicleDailyCheckResultsVM: changedArray,
                    selectedImages: FilterimagesList
                    //   imageUpload: tempArray
                }));
                // pullEditInpectionChecks();
                showToast('Image Removed Successfully');
            }
        } else {
            let objIndex = state.VehicleDailyCheckResultsVM.findIndex((x) => x.inspectionSheetCheckID === state.inspectioncheckID);
            if (objIndex > -1) {
                // let index = state.selectedImages.findIndex((k) => k === val);
                FilterimagesList.splice(i, 1);
                changedArray[objIndex].images = FilterimagesList;
            }
            setState((st) => ({
                ...st,
                VehicleDailyCheckResultsVM: changedArray,
                selectedImages: FilterimagesList
            }));
        }
        setImgLoader(false);
    };

    return (
        <InspectionCheCkContaxt.Provider
            value={{
                btnLoader,
                state,
                flags,
                widths,
                handleInput,
                signCanvas,
                clear,
                GetTechnicianSign,
                imageHandler,
                onImageChange,
                changeState,
                changeNotesState,
                changeResutNotesState,
                changeAllChildChecks,
                handleInputs,
                useDefaultSig,
                handleConfirmPopup,
                submitData,
                sumbitImage,
                setState,
                handleInspection,
                handleInpectionRow,
                closeInspection,
                portalSettings,
                getPreviousTyreData,
                RemoveImage,
                sumbitImageApi,
                onImageChangeAPI,
                imgLoader,
                isModal,
                actionTakenHandle,
                closeActionTakenhandle,
                localFileInputRef,
                apiFileInputRef,
                pullEditInpectionChecks,
                setFlags
            }}
        >
            {props.children}
        </InspectionCheCkContaxt.Provider>
    );
};
